import React,{useState} from 'react';
import {Component, Button, Input} from './styles/addParticipantComponent-style';
import { v4 as uuid } from 'uuid';


const AddParticipantComponent = ({Participants, setParticipants} ) => {
    const [name, setName] = useState('');
    


    function handleParticipantAddition(e) {
        //add component
        const newList = Participants.concat ({id: uuid(), name: name});
        setParticipants(newList);
        setName('');
        e.preventDefault();

    };

    function handleChange(e) {
        setName(e.target.value);
    };


    return (
        <Component className='ParticipantComponent'>
            <Input onChange={handleChange} value={name} placeholder="Enter Particpant Name" />
            <Button onClick={handleParticipantAddition}>Add Particapant</Button>
        </Component>
    );
};

export default AddParticipantComponent;

